/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { CompetitionBrowseFacets } from './CompetitionBrowseFacets';
import {
    CompetitionBrowseFacetsFromJSON,
    CompetitionBrowseFacetsFromJSONTyped,
    CompetitionBrowseFacetsToJSON,
    CompetitionBrowseFacetsToJSONTyped,
} from './CompetitionBrowseFacets';
import type { CompetitionBrowseCard } from './CompetitionBrowseCard';
import {
    CompetitionBrowseCardFromJSON,
    CompetitionBrowseCardFromJSONTyped,
    CompetitionBrowseCardToJSON,
    CompetitionBrowseCardToJSONTyped,
} from './CompetitionBrowseCard';

/**
 * 
 * @export
 * @interface GetCompetitionBrowseResponse
 */
export interface GetCompetitionBrowseResponse {
    /**
     * 
     * @type {Array<CompetitionBrowseCard>}
     * @memberof GetCompetitionBrowseResponse
     */
    competitions: Array<CompetitionBrowseCard>;
    /**
     * 
     * @type {CompetitionBrowseFacets}
     * @memberof GetCompetitionBrowseResponse
     */
    facets: CompetitionBrowseFacets;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetCompetitionBrowseResponse
     */
    paginationInfo: PaginationInfo;
}

/**
 * Check if a given object implements the GetCompetitionBrowseResponse interface.
 */
export function instanceOfGetCompetitionBrowseResponse(value: object): value is GetCompetitionBrowseResponse {
    if (!('competitions' in value) || value['competitions'] === undefined) return false;
    if (!('facets' in value) || value['facets'] === undefined) return false;
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    return true;
}

export function GetCompetitionBrowseResponseFromJSON(json: any): GetCompetitionBrowseResponse {
    return GetCompetitionBrowseResponseFromJSONTyped(json, false);
}

export function GetCompetitionBrowseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompetitionBrowseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'competitions': ((json['competitions'] as Array<any>).map(CompetitionBrowseCardFromJSON)),
        'facets': CompetitionBrowseFacetsFromJSON(json['facets']),
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function GetCompetitionBrowseResponseToJSON(json: any): GetCompetitionBrowseResponse {
    return GetCompetitionBrowseResponseToJSONTyped(json, false);
}

export function GetCompetitionBrowseResponseToJSONTyped(value?: GetCompetitionBrowseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'competitions': ((value['competitions'] as Array<any>).map(CompetitionBrowseCardToJSON)),
        'facets': CompetitionBrowseFacetsToJSON(value['facets']),
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
    };
}

